import { State } from 'src/types'
import { hJointWeb, hWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/hWeb'
import { flatWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/flatWeb'
import { crossWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/crossWeb'
import { crossWebSingleKnot } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/crossWebSingleKnot'
import { crossWebWithLace, crossWebWithLaceWithEdge } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/crossWebWithLace'
import { onePeaceWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/onePeaceWeb'
import { netWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/netWeb'
import { netWeb2 } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/netWeb2'
import { netWebDouble } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/netWebDouble'
import { crossDoubleWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/crossDoubleWeb'
import {
  crossDoubleWebWithLace,
  crossDoubleWebWithLaceWithEdge
} from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/crossDoubleWebWithLace'
import { basketForPitcherWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/basketWeb'
import { twoPeaceWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/twoPeaceWeb'
import { fenceWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/fenceWeb'
import { jointCheckerWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/jointCheckerWeb'
import { lacingNetWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/lacingNetWeb'
import { hWebWithEdge } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/hWebWithEdge'
import { netWebDoubleWithJoint } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/netWebDoubleWithJoint'
import { type2Web } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/type2Web'
import { type7Web } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/type7Web'
import { type1_2Web } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/type1_2Web'
import { type2_2Web } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/type2_2Web'
import { type6Web } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/type6Web'
import { type3Web, type3WebLeftThrow } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/type3Web'
import { type22Web } from './type22Web'
import { type23Web } from './type23Web'
import { type24Web } from './type24Web'
import { webDrawUtil } from 'src/features/brands/util/canvas'
import { type26Web } from './type26Web'
import { type25Web } from './type25Web'
import { type27Web } from './type27Web'
import { type28Web } from './type28Web'

export const webOfGloveBackDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, webColor, web2Color, laceColor, stitchColor, edgeColor } = webDrawUtil(state)
  if (webMatcher(['type1'])) flatWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type1_2'])) type1_2Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type2'])) type2Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type2_2'])) type2_2Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type3'])) {
    switch (state.dominantArm.value) {
      case 'leftThrow':
        type3WebLeftThrow(ctx, webColor, laceColor, stitchColor)
        break
      case 'rightThrow':
      default:
        type3Web(ctx, webColor, laceColor, stitchColor)
        break
    }
  }
  if (webMatcher(['type4'])) basketForPitcherWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type5'])) twoPeaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type6'])) type6Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type7'])) type7Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type8'])) crossWebSingleKnot(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type9'])) crossWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type10'])) crossWebWithLace(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type10_2'])) crossWebWithLaceWithEdge(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['type11'])) onePeaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type12'])) hWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type12_2'])) hWebWithEdge(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['type13'])) hJointWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type14'])) lacingNetWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type15'])) jointCheckerWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['type16'])) netWeb2(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['type16_2'])) netWeb(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['type17'])) netWebDouble(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type18'])) netWebDoubleWithJoint(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type19'])) fenceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type20'])) crossDoubleWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type21'])) crossDoubleWebWithLace(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type21_2'])) crossDoubleWebWithLaceWithEdge(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['type22'])) type22Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type23'])) type23Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type24'])) type24Web(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['type25'])) type25Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type26'])) type26Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type27'])) type27Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type28'])) type28Web(ctx, webColor, edgeColor, laceColor, stitchColor)
}
